import { Stack, Tabs } from '@mantine/core'
import { useQueryParamTab } from 'src/utils/tabQueryParam'
import HomeContent from './Home'
import UserCountryPage from 'src/pages/Country'
import ProvincePage from 'src/pages/Province'

function HomePage() {
	const tabValues = ['home', 'country', 'province'] as const
	const { activeTab, handleTabChange } = useQueryParamTab(tabValues, 'home')

	return (
		<Stack
			sx={{
				width: '100%',
			}}
		>
			<Tabs value={activeTab} onTabChange={handleTabChange} keepMounted={false}>
				<Tabs.List>
					<Tabs.Tab value="home" fw={700}>Home</Tabs.Tab>
					<Tabs.Tab value="country" fw={700}>User by Country</Tabs.Tab>
					<Tabs.Tab value="province" fw={700}> User by Province</Tabs.Tab>
				</Tabs.List>

				<Tabs.Panel value="home" pt="md">
					<HomeContent />
				</Tabs.Panel>

				<Tabs.Panel value="country" pt="md">
					<UserCountryPage />
				</Tabs.Panel>

				<Tabs.Panel value="province" pt="md">
					<ProvincePage />
				</Tabs.Panel>
			</Tabs>
		</Stack>
	)
}

export default HomePage
